"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTopics = exports.getReadableCuratedContent = exports.getListReadableCategoryOrderTopics = exports.getListReadableCategoryContent = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var getListReadableCategoryOrderTopics = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(id) {
    var _yield$axios$post, data;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.post('/categoryV2/listReadableCategoryOrderTopics', {
              categoryId: id
            });

          case 2:
            _yield$axios$post = _context.sent;
            data = _yield$axios$post.data;
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getListReadableCategoryOrderTopics(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.getListReadableCategoryOrderTopics = getListReadableCategoryOrderTopics;

var getListReadableCategoryContent = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(id, type, pagination) {
    var _yield$axios$post2, data;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.post('/categoryV2/listReadableCategoryContent', {
              categoryId: id,
              type: type,
              pagination: pagination
            });

          case 2:
            _yield$axios$post2 = _context2.sent;
            data = _yield$axios$post2.data;
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getListReadableCategoryContent(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getListReadableCategoryContent = getListReadableCategoryContent;

var getReadableCuratedContent = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(id, type, pagination) {
    var _yield$axios$post3, data;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.post('/categoryV2/getReadableCuratedContent', {
              categoryId: id,
              type: type,
              pagination: pagination
            });

          case 2:
            _yield$axios$post3 = _context3.sent;
            data = _yield$axios$post3.data;
            return _context3.abrupt("return", data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getReadableCuratedContent(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

exports.getReadableCuratedContent = getReadableCuratedContent;

var getTopics = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(containerIds, sort, filters, pagination) {
    var _yield$axios$post4, data;

    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _axios.default.post('/contentNavigation/topics', {
              containerIds: containerIds,
              sort: sort,
              filters: filters,
              pagination: pagination
            });

          case 2:
            _yield$axios$post4 = _context4.sent;
            data = _yield$axios$post4.data;
            return _context4.abrupt("return", data);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getTopics(_x8, _x9, _x10, _x11) {
    return _ref4.apply(this, arguments);
  };
}();

exports.getTopics = getTopics;